var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_475_27777",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 18.3332C11.0946 18.3346 12.1787 18.1197 13.1899 17.7008C14.2012 17.2819 15.1196 16.6673 15.8926 15.8923C16.6676 15.1194 17.2822 14.2009 17.7011 13.1897C18.1199 12.1784 18.3348 11.0944 18.3334 9.99984C18.3348 8.90529 18.1199 7.82125 17.701 6.81002C17.2821 5.79879 16.6676 4.88031 15.8926 4.10734C15.1196 3.33236 14.2012 2.71776 13.1899 2.29888C12.1787 1.88 11.0946 1.66509 10.0001 1.66651C8.90554 1.66512 7.8215 1.88003 6.81027 2.29891C5.79904 2.71779 4.88055 3.33237 4.10759 4.10734C3.33262 4.88031 2.71804 5.79879 2.29916 6.81002C1.88028 7.82125 1.66536 8.90529 1.66676 9.99984C1.66534 11.0944 1.88024 12.1784 2.29912 13.1897C2.718 14.2009 3.3326 15.1194 4.10759 15.8923C4.88055 16.6673 5.79904 17.2819 6.81027 17.7008C7.8215 18.1197 8.90554 18.3346 10.0001 18.3332Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 10L9.16675 12.5L14.1667 7.5",
    stroke: "black",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_475_27777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "#00A6A6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/CheckCircle.252f3e3252076bb8072a69488cc9b086.svg";
export { ForwardRef as ReactComponent };